import { render, staticRenderFns } from "./ExamineFollowList.vue?vue&type=template&id=5029a408&scoped=true&"
import script from "./ExamineFollowList.vue?vue&type=script&lang=js&"
export * from "./ExamineFollowList.vue?vue&type=script&lang=js&"
import style0 from "./ExamineFollowList.vue?vue&type=style&index=0&id=5029a408&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5029a408",
  null
  
)

export default component.exports